import { useCallback, useEffect, useState } from 'react';

import { useFormikContext } from 'formik';

import useStoreTranslation from 'hooks/useStoreTranslation';
import useToast from 'hooks/useToast';

/**
 * This component exists only to capture Formik's renderProps and track form submission events.
 * See: https://github.com/jaredpalmer/formik/issues/1484#issuecomment-490558973
 */
const FormikSubmitErrorEffect = () => {
  const toast = useToast();
  const { t } = useStoreTranslation();
  const formik = useFormikContext();

  const [lastHandled, setLastHandled] = useState(0);

  const onSubmitError = useCallback(() => {
    toast.add({ type: 'danger', message: t('error.toast') });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [t, toast]);

  useEffect(() => {
    if (formik.submitCount > lastHandled && !formik.isSubmitting && !formik.isValid) {
      onSubmitError();
      setLastHandled(formik.submitCount);
    }
  }, [lastHandled, onSubmitError, formik.submitCount, formik.isValid, formik.isSubmitting]);

  return null;
};

export default FormikSubmitErrorEffect;
